import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import BitcoinMiningSimulator from './App';

ReactDOM.render(
  <React.StrictMode>
    <BitcoinMiningSimulator />
  </React.StrictMode>,
  document.getElementById('root')
);